import { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة العمر بالهجري - احسب عمرك بدقة - حساب العمر بالهجري ";
const DESCRIPTION =
  "حاسبة العمر بالهجري تمكنك من حساب العمر بالهجري من خلال ادخال تاريخ الميلاد سواء بالتاريخ الهجري أم الميلادي - استخدم حاسبة العمر بالهجري لتحويل التواريخ الى اعمار دقيقة حسب التقويم الهحري والاسلامي";
const KEYWORDS =
  "حساب العمر بالهجري, حاسبة العمر بالهجري, تحويل التاريخ إلى العمر الهجري, حاسبة العمر الهجري, العمر الهجري, تحويل التاريخ إلى سنوات هجرية, حساب العمر بالتاريخ الهجري, حاسبة العمر الاحترافية الهجرية, حساب العمر الدقيق بالهجري, تاريخ الهجرة إلى عمر فعلي, حساب عمر الشخص بالتاريخ الهجري, حساب العمر حسب التقويم الهجري";
const OG_URL = "https://do-calculate.com/calculator/ar/agehijri/";

// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "حاسبة العمر بالهجري",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "جميع الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "حاسبة العمر بالهجري",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "ماهو العمر الهجري",
        acceptedAnswer: {
          "@type": "Answer",
          text: "العمر الهجري هو الطريقة التي نستخدمها لقياس عمر الشخص بناءً على تاريخ ميلاده وفقاً للتقويم الهجري الشهري والسنوي.",
        },
      },
      {
        "@type": "Question",
        name: "كيف يمكنني حساب العمر الهجري؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "يمكنك حساب العمر الهجري بإدخال تاريخ ميلادك في الحاسبة، وستقوم تلقائياً بحساب عمرك بالسنوات والأشهر والأيام والساعات بدقة تامة.",
        },
      },
      {
        "@type": "Question",
        name: "ما هي استخدامات حساب العمر الهجري؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "يُستخدم حساب العمر الهجري في التأمل في تجربة الحياة، تخطيط المستقبل، تحديد الأهداف الشخصية، وفي مجالات التأمين والتقاعد والرعاية الصحية.",
        },
      },
    ],
  },
];
const DAYS_OF_WEEK = [
  "الأحد",
  "الاثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
];
const GREGORIAN_MONTHS = [
  "كانون الثاني",
  "شباط",
  "آذار",
  "نيسان",
  "أيار",
  "حزيران",
  "تموز",
  "آب",
  "أيلول",
  "تشرين الأول",
  "تشرين الثاني",
  "كانون الأول",
];
const HIJRI_MONTHS = [
  "محرم",
  "صفر",
  "ربيع الأول",
  "ربيع الثاني",
  "جمادى الأولى",
  "جمادى الآخرة",
  "رجب",
  "شعبان",
  "رمضان",
  "شوال",
  "ذو القعدة",
  "ذو الحجة",
];
const SEASONS = [
  {
    name: "الشتاء",
    start: { month: 12, day: 21 },
    end: { month: 3, day: 20 },
  },
  { name: "الربيع", start: { month: 3, day: 21 }, end: { month: 6, day: 20 } },
  { name: "الصيف", start: { month: 6, day: 21 }, end: { month: 9, day: 22 } },
  {
    name: "الخريف",
    start: { month: 9, day: 23 },
    end: { month: 12, day: 20 },
  },
];
// Helper function to convert Hijri to Gregorian
const hijriToGregorian = (hijriDay, hijriMonth, hijriYear) => {
  // This is a simplified conversion. For production, use a proper library like hijri-converter
  const adjustment = Math.floor(hijriYear * 0.97); // Approximate adjustment factor
  const gregorianYear = hijriYear + 622 - adjustment;
  // Simplified month and day mapping (this is not accurate, just for demonstration)
  // In production, use a proper conversion library
  const monthDays = [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29]; // Hijri months
  let totalDays = 0;
  for (let i = 0; i < hijriMonth - 1; i++) {
    totalDays += monthDays[i];
  }
  totalDays += hijriDay - 1;
  // Convert to Gregorian days (approximate)
  const gregorianDays = Math.floor(totalDays * 1.0307);
  const date = new Date(gregorianYear, 0, 1);
  date.setDate(date.getDate() + gregorianDays);
  return date;
};
// Helper function to get current Hijri year
const getCurrentHijriYear = () => {
  const currentDate = new Date();
  const currentGregorianYear = currentDate.getFullYear();
  // Approximate calculation: Hijri year = (Gregorian year - 622) * 1.03
  return Math.floor((currentGregorianYear - 622) * 1.03);
};
function AgeCalculatorHijri() {
  const [convertedValue, setConvertedValue] = useState("hijri");
  const [dateOfBirthGregorian, setDateOfBirthGregorian] = useState({
    day: "",
    month: "",
    year: ""
  });
  const [dateOfBirthHijri, setDateOfBirthHijri] = useState({
    day: "",
    month: "",
    year: ""
  });
  const [ageResult, setAgeResult] = useState(null);
  const [error, setError] = useState(null);
  const [hijriYears, setHijriYears] = useState([]);
  // Generate Hijri years list
  useEffect(() => {
    const currentHijriYear = getCurrentHijriYear();
    const years = [];
    // Generate years from 1300 to current Hijri year + 10
    for (let year = 1300; year <= currentHijriYear + 10; year++) {
      years.push(year);
    }
    setHijriYears(years);
  }, []);
  const handleConversionValueChange = (newConversionType) => {
    setConvertedValue(newConversionType);
    setError(null);
    setDateOfBirthGregorian({ day: "", month: "", year: "" });
    setDateOfBirthHijri({ day: "", month: "", year: "" });
    setAgeResult(null);
  };
  const calculateAge = (birthDate, isHijri = false) => {
    const today = new Date();
    const birth = new Date(birthDate);
    if (isNaN(birth.getTime()) || birth > today) {
      setError("يُرجى إدخال تاريخ ميلاد صحيح");
      setAgeResult(null);
      return;
    }
    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();
    let days = today.getDate() - birth.getDate();
    if (days < 0) {
      months--;
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    const hours = today.getHours() - birth.getHours();
    const minutes = today.getMinutes() - birth.getMinutes();
    const seconds = today.getSeconds() - birth.getSeconds();
    // Calculate total time units
    const totalDays = Math.floor((today - birth) / (1000 * 60 * 60 * 24));
    const totalHours = Math.floor((today - birth) / (1000 * 60 * 60));
    const totalMinutes = Math.floor((today - birth) / (1000 * 60));
    const totalSeconds = Math.floor((today - birth) / 1000);
    const totalWeeks = Math.floor(totalDays / 7);
    const totalMonths = years * 12 + months;
    // Calculate next birthday
    let nextBirthday = new Date(
      today.getFullYear(),
      birth.getMonth(),
      birth.getDate()
    );
    if (nextBirthday < today) {
      nextBirthday.setFullYear(today.getFullYear() + 1);
    }
    const daysUntilBirthday = Math.ceil(
      (nextBirthday - today) / (1000 * 60 * 60 * 24)
    );
    // Get day of week born
    const dayOfWeekBorn = DAYS_OF_WEEK[birth.getDay()];
    // Get birth month in Arabic
    const birthMonthArabic = isHijri
      ? HIJRI_MONTHS[birth.getMonth()]
      : GREGORIAN_MONTHS[birth.getMonth()];
    // Get season born
    const birthMonth = birth.getMonth() + 1;
    const birthDay = birth.getDate();
    let seasonBorn = "";
    for (const season of SEASONS) {
      if (season.name === "الشتاء") {
        if (birthMonth === 12 || birthMonth <= 3) {
          if (
            (birthMonth === 12 && birthDay >= 21) ||
            birthMonth < 3 ||
            (birthMonth === 3 && birthDay <= 20)
          ) {
            seasonBorn = season.name;
            break;
          }
        }
      } else {
        const inStartRange =
          birthMonth > season.start.month ||
          (birthMonth === season.start.month && birthDay >= season.start.day);
        const inEndRange =
          birthMonth < season.end.month ||
          (birthMonth === season.end.month && birthDay <= season.end.day);
        if (inStartRange && inEndRange) {
          seasonBorn = season.name;
          break;
        }
      }
    }
    // Life milestone
    let lifeMilestone = "";
    if (years < 1) lifeMilestone = "رضيع";
    else if (years < 3) lifeMilestone = "طفل صغير";
    else if (years < 13) lifeMilestone = "طفل";
    else if (years < 20) lifeMilestone = "مراهق";
    else if (years < 40) lifeMilestone = "شاب";
    else if (years < 60) lifeMilestone = "منتصف العمر";
    else lifeMilestone = "كبير السن";
    setAgeResult({
      years,
      months,
      days,
      hours: Math.abs(hours),
      minutes: Math.abs(minutes),
      seconds: Math.abs(seconds),
      totalDays,
      totalHours,
      totalMinutes,
      totalSeconds,
      totalWeeks,
      totalMonths,
      daysUntilBirthday,
      dayOfWeekBorn,
      birthMonthArabic,
      seasonBorn,
      lifeMilestone,
      heartbeats: Math.floor(totalDays * 100000),
      breaths: Math.floor(totalDays * 20000),
      sleepHours: Math.floor(totalHours / 3),
      mealsEaten: Math.floor(totalDays * 3),
    });
    setError(null);
  };
  const handleCalculate = () => {
    if (convertedValue === "gregorian") {
      if (!dateOfBirthGregorian.day || !dateOfBirthGregorian.month || !dateOfBirthGregorian.year) {
        setError("يُرجى إدخال تاريخ الميلاد كاملاً");
        return;
      }
      // Validate day based on month
      const day = parseInt(dateOfBirthGregorian.day);
      const month = parseInt(dateOfBirthGregorian.month);
      const year = parseInt(dateOfBirthGregorian.year);
      // Check for valid date
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        setError("تاريخ الميلاد غير صحيح");
        return;
      }
      // Create date string in YYYY-MM-DD format
      const dateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      calculateAge(dateString, false);
    } else {
      if (!dateOfBirthHijri.day || !dateOfBirthHijri.month || !dateOfBirthHijri.year) {
        setError("يُرجى إدخال تاريخ الميلاد كاملاً");
        return;
      }
      const hijriDay = parseInt(dateOfBirthHijri.day);
      const hijriMonth = parseInt(dateOfBirthHijri.month);
      const hijriYear = parseInt(dateOfBirthHijri.year);
      // Simple validation for Hijri date
      if (hijriDay < 1 || hijriDay > 30 || hijriMonth < 1 || hijriMonth > 12 || hijriYear < 1) {
        setError("تاريخ هجري غير صحيح");
        return;
      }
      // Convert Hijri to Gregorian for calculation
      const gregorianDate = hijriToGregorian(hijriDay, hijriMonth, hijriYear);
      calculateAge(gregorianDate, true);
    }
  };
  // Get days in month for Hijri
  const getHijriDaysInMonth = (month) => {
    // Hijri months have 29 or 30 days
    const longMonths = [1, 3, 5, 7, 9, 11]; // Odd months are usually 30 days
    if (longMonths.includes(parseInt(month))) {
      return 30;
    }
    return 29; // Even months are usually 29 days
  };
  return (
    <div style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                حاسبة العمر بالهجري تساعدك لحساب العمر الهجري بسرعة ودقة ضمن التقويم الهجري والاسلامي. تقوم الحاسبة بارجاع التاريخ المحسوب عرض العمر المحسوب بالسنوات والشهور والأيام والساعات والدقائق والثواني.
              </p>
              <ul> لحساب العمر بالتاريخ الهجري بدقة، تقوم الحاسبة باتباع الخطوات التالية
                <li> تحديد تاريخ ميلاد الشخص: يجب أن تكون على دراية بتاريخ ميلاد الشخص الذي ترغب في حساب عمره بالتاريخ الهجري
                </li>
                <li>حساب عدد السنوات: ابدأ بحساب عدد السنوات بين تاريخ ميلاد الشخص واليوم الحالي باستخدام التقويم الهجري.
                </li>
                <li>مراعاة الأشهر والأيام: بعد حساب السنوات، قم بمراعاة الأشهر والأيام الهجرية للحصول على عمر دقيق بالتاريخ الهجري.
                </li>
              </ ul>
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                يمكن لـ "حاسبة العمر" تحديد العمر الهجري. سيتم عرض العمر المحسوب بالسنوات والشهور والأيام والساعات والدقائق والثواني. احسب عمرك بالهجري من خلال ادخال تاريخ الميلاد سواء بالتاريخ الهجري أم الميلادي - استخدم حاسبة العمر بالهجري لتحويل التواريخ الى اعمار دقيقة حسب التقويم الهجري'
              </p>
            </div>
            <hr />
            <MobileUnderCalAds /> <hr />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-3">
              <div className="p-3 mb-3 bg-success text-white rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>احسب عمرك الآن</h2>
              </div>
              <div className="row">
                <div
                  className="form-group d-flex align-items-center"
                  style={{
                    columnGap: "25px",
                    margin: "5px 15px 25px 0",
                  }}
                >
                  <label >
                    <strong>نوع التاريخ:</strong>
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateType"
                      id="gregorian"
                      value="gregorian"
                      checked={convertedValue === "gregorian"}
                      onChange={() => handleConversionValueChange("gregorian")}
                    />
                    <label className="form-check-label" htmlFor="gregorian">
                      ميلادي
                    </label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateType"
                      id="hijri"
                      value="hijri"
                      checked={convertedValue === "hijri"}
                      onChange={() => handleConversionValueChange("hijri")}
                    />
                    <label className="form-check-label" htmlFor="hijri">
                      هجري
                    </label>
                  </div>
                </div>
              </div>
              {convertedValue === "gregorian" ? (
                <div className="row">
                  <div className="col-md-12">
                    <label
                      htmlFor="dateOfBirth"
                      
                      style={{ fontSize: "16px" }}
                    >
                      أدخل تاريخ ميلادك في التقويم الميلادي:
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>اليوم</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.day || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, day: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">اليوم</option>
                          {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>{day}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>الشهر</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.month || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, month: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">الشهر</option>
                          {GREGORIAN_MONTHS.map((month, index) => (
                            <option key={index} value={index + 1}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>السنة</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.year || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, year: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">السنة</option>
                          {Array.from(
                            { length: new Date().getFullYear() - 1899 },
                            (_, i) => new Date().getFullYear() - i
                          ).map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    <label
                      htmlFor="hijriDatePicker"
                      
                      style={{ fontSize: "16px" }}
                    >
                      أدخل تاريخ ميلادك في التقويم الهجري:
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>اليوم</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.day || ""}
                          onChange={(e) => {
                            setDateOfBirthHijri({ ...dateOfBirthHijri, day: e.target.value });
                          }}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">اليوم</option>
                          {dateOfBirthHijri.month ?
                            Array.from(
                              { length: getHijriDaysInMonth(dateOfBirthHijri.month) },
                              (_, i) => i + 1
                            ).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))
                            :
                            Array.from({ length: 30 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))
                          }
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>الشهر</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.month || ""}
                          onChange={(e) => {
                            setDateOfBirthHijri({ ...dateOfBirthHijri, month: e.target.value, day: "" });
                          }}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">الشهر</option>
                          {HIJRI_MONTHS.map((month, index) => (
                            <option key={index} value={index + 1}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label  style={{ fontSize: "14px" }}>السنة</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.year || ""}
                          onChange={(e) => setDateOfBirthHijri({ ...dateOfBirthHijri, year: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">السنة</option>
                          {hijriYears.map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <br />
              <div className="text-center mb-3 mt-4">
                <button
                  className="btn btn-success"
                  onClick={handleCalculate}
                >
                  احسب عمري
                </button>
              </div>
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>تنبيه:</strong> {error}
                </div>
              )}
              {ageResult && (
                <div
                  className="alert alert-success"
                  role="alert"
                  style={{ fontSize: "16px" }}
                >
                  <h3 style={{ fontSize: "20px", marginBottom: "15px" }}>
                    <strong>نتيجة حساب العمر:</strong>
                  </h3>
                  <div className="mb-3 p-3 bg-light rounded">
                    <strong style={{ fontSize: "18px" }}>عمرك هو:</strong>
                    <p style={{ fontSize: "17px", marginTop: "10px" }}>
                      {ageResult.years} سنة و {ageResult.months} شهر و{" "}
                      {ageResult.days} يوم
                    </p>
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>عمرك بالتفصيل الدقيق</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>✓ السنوات: {ageResult.years}</li>
                          <li>✓ الأشهر: {ageResult.months}</li>
                          <li>✓ الأيام: {ageResult.days}</li>
                          <li>✓ الساعات: {ageResult.hours}</li>
                          <li>✓ الدقائق: {ageResult.minutes}</li>
                          <li>✓ الثواني: {ageResult.seconds}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>إحصائيات إجمالية</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            📅 إجمالي الأيام المعاشة:{" "}
                            {ageResult.totalDays.toLocaleString()} يوم
                          </li>
                          <li>
                            📅 إجمالي الأسابيع:{" "}
                            {ageResult.totalWeeks.toLocaleString()} أسبوع
                          </li>
                          <li>
                            📅 إجمالي الأشهر:{" "}
                            {ageResult.totalMonths.toLocaleString()} شهر
                          </li>
                          <li>
                            ⏰ إجمالي الساعات:{" "}
                            {ageResult.totalHours.toLocaleString()} ساعة
                          </li>
                          <li>
                            ⏰ إجمالي الدقائق:{" "}
                            {ageResult.totalMinutes.toLocaleString()} دقيقة
                          </li>
                          <li>
                            ⏰ إجمالي الثواني:{" "}
                            {ageResult.totalSeconds.toLocaleString()} ثانية
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>معلومات شيقة عن حياتك</strong>
                      </div>
                      <div className="info-section-body">
                        <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>
                          معلومات عامة:
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>🗓️ ولدت يوم: {ageResult.dayOfWeekBorn}</li>
                          <li>📅 في شهر: {ageResult.birthMonthArabic}</li>
                          <li>🌸 في فصل: {ageResult.seasonBorn}</li>
                          <li>
                            🎂 الأيام المتبقية لعيد ميلادك القادم:{" "}
                            {ageResult.daysUntilBirthday} يوم
                          </li>
                          <li>👤 مرحلة الحياة: {ageResult.lifeMilestone}</li>
                        </ul>
                        <h4
                          style={{
                            fontSize: "16px",
                            marginTop: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          حقائق مذهلة حصلت في حياتك (تقريباً):
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            💓 نبض قلبك حوالي:{" "}
                            {ageResult.heartbeats.toLocaleString()} مرة
                          </li>
                          <li>
                            🫁 تنفست حوالي:{" "}
                            {ageResult.breaths.toLocaleString()} نفس
                          </li>
                          <li>
                            😴 أمضيت نائماً حوالي:{" "}
                            {ageResult.sleepHours.toLocaleString()} ساعة (
                            {Math.floor(ageResult.sleepHours / 24).toLocaleString()}{" "}
                            يوم)
                          </li>
                          <li>
                            🍽️ تناولت حوالي:{" "}
                            {ageResult.mealsEaten.toLocaleString()} وجبة
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                العمر بالتاريخ الهجري: دليل شامل لحساب العمر بدقة وفقًا للتقويم
                الهجري
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    العمر بالتاريخ الهجري: تحويل وحساب دقيق{" "}
                  </h2>{" "}
                </u>
                <p>
                  تُعدّ الأعمال الحضارية والتقاليد الثقافية من أهم الجوانب التي
                  تميز الثقافات المختلفة حول العالم. ومن أبرز الثقافات التي
                  تتمتع بتقويم زمني خاص بها تقويم الهجري، الذي يستخدم بشكل واسع
                  في العالم الإسلامي. في هذا المقال، سنتناول موضوع حساب العمر
                  بالتاريخ الهجري وكيف يمكن تحويل التاريخ إلى العمر الهجري بدقة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}> مفهوم العمر الهجري </h2>{" "}
                </u>
                <p>
                  العمر الهجري هو الطريقة التي يتم بها حساب عمر الشخص باستخدام
                  تقويم الهجري. يعتمد هذا النوع من الحسابات على السنوات الهجرية
                  والأشهر الهجرية والأيام الهجرية. تُستخدم هذه الطريقة بشكل
                  رئيسي في العالم الإسلامي لحساب الأعمار وتحديد الأحداث الدينية
                  والمناسبات.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب العمر بالتاريخ الهجري{" "}
                  </h2>{" "}
                </u>
                لحساب العمر بالتاريخ الهجري بدقة، يجب أن تتبع الخطوات التالية:
                <ul>
                  <li>
                    تحديد تاريخ ميلاد الشخص: يجب أن تكون على دراية بتاريخ ميلاد
                    الشخص الذي ترغب في حساب عمره بالتاريخ الهجري.
                  </li>
                  <li>
                    حساب عدد السنوات: ابدأ بحساب عدد السنوات بين تاريخ ميلاد
                    الشخص واليوم الحالي باستخدام التقويم الهجري.
                  </li>
                  <li>
                    مراعاة الأشهر والأيام: بعد حساب السنوات، قم بمراعاة الأشهر
                    والأيام الهجرية للحصول على عمر دقيق بالتاريخ الهجري.
                  </li>
                </ul>
                <p></p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    استخدام حاسبة العمر الهجري الدقيقة{" "}
                  </h2>{" "}
                </u>
                <p>
                  لتسهيل عملية حساب العمر بالتاريخ الهجري، يمكنك استخدام حاسبة
                  العمر الهجري الدقيقة. هذه الأداة تقوم بتحويل تاريخ الميلاد إلى
                  العمر الهجري بسرعة ودقة. كل ما عليك فعله هو إدخال تاريخ
                  الميلاد، وستقوم الحاسبة بتقديم النتيجة بشكل فوري.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    استخدامات حساب العمر بالتاريخ الهجري{" "}
                  </h2>{" "}
                </u>
                <p>
                  يُستخدم حساب العمر بالتاريخ الهجري في العديد من السياقات داخل
                  العالم الإسلامي. يمكن استخدامه لتحديد الأعياد والمناسبات
                  الدينية مثل شهر رمضان وعيد الفطر، وأيضًا لحساب الأعمار في
                  الوثائق الرسمية والتراخيص.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيف تعمل حاسبة العمر الهجرية{" "}
                  </h2>{" "}
                </u>
                <p>
                  تعود استخدام التقويم الهجري لحساب عمر الإنسان إلى التاريخ
                  الإسلامي. التقويم الهجري يستند إلى هجرة النبي محمد صلى الله
                  عليه وسلم من مكة إلى المدينة في عام 622. يتكون العام الهجري من
                  12 شهرًا، ويختلف عدد أيام كل شهر حسب التقويم الهجري. العام
                  الهجري أقصر من العام الميلادي، وبالتالي يختلف التاريخ في
                  العامين. <br />
                </p>
                <p>
                  عمر الإنسان في التقويم الهجري يعتمد على تاريخ ميلاده والتاريخ
                  الحالي في التقويم الهجري. يمكن حساب العمر بالأعوام والشهور
                  والأيام والساعات والدقائق والثواني. <br />
                </p>
                <p>
                  ولكن، يجب أن أوضح أن العمر الدقيق في التقويم الهجري يعتمد على
                  الوقت الحالي والتاريخ الهجري لحظة تشغيل الكود. إذا كان الكود
                  يُشغَل في وقت محدد، فسيعطيك العمر الحالي وفقًا لذلك التاريخ.{" "}
                  <br />
                </p>
                <p>
                  على سبيل المثال، إذا كانت اليوم هو 27 مايو 2023 وتاريخ الميلاد
                  هو 1 محرم 1421، فسيتم حساب العمر بناءً على هذه الفروق الزمنية
                  والتاريخ الهجري. <br />
                </p>
                <p></p>
                <p></p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هو العمر الهجري؟</h3>
              </div>
              <div className="info-section-body">
                العمر الهجري هو الطريقة التي نستخدمها لقياس عمر الشخص باستخدام
                تقويم الهجري، وهو التقويم الذي يُستخدم في العالم الإسلامي.
                <br />
                <label>
                  المصدر:{" "}
                  <a href="https://ar.wikipedia.org/wiki/%D8%AA%D9%82%D9%88%D9%8A%D9%85_%D9%87%D8%AC%D8%B1%D9%8A">
                    ويكيبيديا
                  </a>
                </label>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يمكنني حساب العمر الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                يمكنك حساب العمر الهجري ببساطة باتباع هذه الخطوات:
                <ol>
                  <li>حدد تاريخ الميلاد.</li>
                  <li>
                    احسب عدد السنوات بين تاريخ الميلاد واليوم الحالي باستخدام
                    التقويم الهجري.
                  </li>
                  <li>مراعاة الأشهر والأيام الهجرية للحصول على عمر دقيق.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل هناك حاسبة لحساب العمر الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، هناك العديد من الحاسبات عبر الإنترنت التي تساعدك في حساب
                العمر الهجري بدقة. ما عليك سوى إدخال تاريخ الميلاد، وستقوم
                الحاسبة بتحويله إلى العمر الهجري بشكل آلي.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي استخدامات العمر الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                العمر الهجري يستخدم بشكل شائع في العالم الإسلامي لتحديد الأعياد
                والمناسبات الدينية مثل شهر رمضان وعيد الفطر. كما يستخدم أيضًا في
                تراخيص الزواج والوثائق الرسمية.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكن حساب العمر الهجري يدويًا؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، يمكن حساب العمر الهجري يدويًا باستخدام القوانين الميلادية
                المعترف بها. ببساطة، قم بحساب السنوات بين تاريخ الميلاد واليوم
                الحالي بالهجري ومن ثم مراعاة الأشهر والأيام.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي أهمية حساب العمر الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                حساب العمر الهجري ذو أهمية كبيرة في العالم الإسلامي، حيث يتم
                استخدامه لتحديد المواعيد الدينية والشرعية ومراقبة الأحداث
                الدينية. كما يُستخدم في الوثائق الرسمية والعقود وفي أغراض
                التراخيص.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorHijri;
